import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  button {
    margin: 15px;
  }
`;

const CustomButton = styled.button`
  font-size: 1.5em;
  text-align: center;
  border: 7px solid #666666;
  margin: 15px;
  width: 15em;
  padding: 5px;
  box-shadow: -5px 5px 15px #888888;
  cursor: pointer;
`;

/**
 * Localhost-only landing page. Surfaces developer tooling for picking an MSW
 * mock scenario or pointing the app at a live environment via a token.
 * This is never rendered on deployed environments.
 */
const LocalLanding: () => React.ReactElement = () => {
  const [liveToken, setLiveToken] = React.useState<string | null>(null);

  const setLiveTokenHandler = React.useCallback(
    (environment: string) => {
      document.cookie = `unumEnterpriseSSO_${environment}=${liveToken}; Secure`;
      // Dedicated cookie for the Vite dev proxy so it knows which
      // environment to route to (no Secure flag — must reach http://localhost).
      document.cookie = `proxy_env=${environment}; path=/`;
      sessionStorage.setItem('mock_source', 'proxy');
      sessionStorage.setItem('mock_env', environment);
      window.location.assign('/app');
    },
    [liveToken],
  );

  const mock = React.useCallback((mockFile: string) => {
    sessionStorage.setItem('mockFile', mockFile);
    sessionStorage.setItem('mock_source', 'browser');
    window.location.assign('/app');
  }, []);

  return (
    <Container id="local-landing">
      {process.env.VITE_MOCK && (
        <>
          <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-5">
            <div className="tw-text-center tw-w-full tw-size-4 tw-mb-2">
              Live Environment Token
            </div>
            <input
              className="tw-mt-5"
              type="text"
              onChange={(e) => setLiveToken(e.target.value)}
            />
            <div className="tw-flex tw-justify-center">
              <button
                disabled={!liveToken?.length}
                onClick={() => setLiveTokenHandler('DEV')}
              >
                DEV
              </button>
              <button
                disabled={!liveToken?.length}
                onClick={() => setLiveTokenHandler('ITEST')}
              >
                ITEST
              </button>
              <button
                disabled={!liveToken?.length}
                onClick={() => setLiveTokenHandler('ACPT')}
              >
                ACPT
              </button>
              <button
                disabled={!liveToken?.length}
                onClick={() => setLiveTokenHandler('')}
              >
                PROD
              </button>
            </div>
          </div>
          <CustomButton onClick={() => mock('data-benjamin-cochran')}>
            Mock Benjamin Cochran
          </CustomButton>
          <CustomButton onClick={() => mock('data-lisa-goodman')}>
            Mock Lisa Goodman
          </CustomButton>
          <CustomButton onClick={() => mock('data-thomas-cisneros')}>
            Thomas Cisneros
          </CustomButton>
          <CustomButton onClick={() => mock('data-carmen-watson')}>
            Carmen Watson
          </CustomButton>
        </>
      )}
    </Container>
  );
};

export { LocalLanding };
